/* unplugin-vue-components disabled */import script from "./productSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./productSummary.vue?vue&type=script&lang=ts&setup=true"

import "./productSummary.vue?vue&type=style&index=0&id=7cde8452&lang=scss&scoped=true"
import "./productSummary.vue?vue&type=style&index=1&id=7cde8452&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cde8452"]])

export default __exports__